var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-textarea',_vm._g(_vm._b({staticClass:"v-input--is-disabled",attrs:{"readonly":"","hide-details":"","no-resize":"","auto-grow":"","rows":"1","label":_vm.label,"value":_vm.value}},'v-textarea',_vm.$attrs,false),on))]}}])},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }